<template>
  <v-container>
    <v-card overflow-auto class="pa-2 tablecard">
        <v-row>
      <v-col>
        <!-- By customer request, deal with discrete inhabitant numbers and operators -->
        <div>
          <p class="text-button button-spacer">Einwohnerzahl</p>
          <v-btn v-if="einwohnerFilterGreater" @click="einwohnerFilterGreater = !einwohnerFilterGreater;">größer</v-btn>
          <v-btn v-else @click="einwohnerFilterGreater = !einwohnerFilterGreater;">kleiner</v-btn>
          <v-btn @click="einwohnerValueHandler"> {{ einwohnerValue.toLocaleString() }}</v-btn>
        </div>
      </v-col>
      <!-- Toggle other attribute filters by cycling the resp reactive value -->
      <v-col>
        <div>
          <p class="text-button button-spacer">Wärmeplanung im Konvoi</p>
          <v-btn @click="cycleValue('bl_konvoi')">{{ boolToLang(bl_konvoi) }}</v-btn>
        </div>
    </v-col>
    <v-col>
    <div>
      <p class="text-button button-spacer">Vereinfachtes Verfahren</p>
      <v-btn @click="cycleValue('bl_vereinfacht')">{{ boolToLang(bl_vereinfacht) }}</v-btn>
    </div>
    </v-col>
    <v-col>
      <div>
        <p class="text-button button-spacer">Verkürztes Verfahren</p>
        <v-btn @click="cycleValue('bl_verkuerzt')">{{ boolToLang(bl_verkuerzt) }}</v-btn>
      </div>
    </v-col>
    <v-col>
    <div>
      <p class="text-button button-spacer">Maßnahmen vorhanden</p>
      <v-btn @click="cycleValue('bl_measures')">{{ boolToLang(bl_measures) }}</v-btn>
    </div>
    </v-col>
    <v-col>
    <div>
      <p class="text-button button-spacer">Maßnahmen-Themen</p>
      <v-select
        label="Themen Filtern"
        :items=measuresOptions
        item-text="title"
        item-value="value"
        v-model="selectedMeasure"
        @change="attrFilter()"
      ></v-select>
    </div>
    </v-col>
    <!-- The actual table -->
    </v-row>
    <v-divider></v-divider>

      <v-card-title class="text--primary py-0">
      Kommunen
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Suche"
        append-icon="mdi-magnify"
        class="mb-4"
        @keyup="textFilter"
      >
      </v-text-field>
      </v-card-title>
      <v-data-table
        density="compact"
        :expanded="expanded"
        dense
        :headers="headers"
        :items="modifiedData"
        :search="search"
        item-value="plz"
        item-key="plz"
        :items-per-page="50"
        hover
        multi-sort
        show-expand
      >
      <template #item.data-table-expand="{ item, expand, isExpanded }">
        <!-- Attention: We are using the modified (Plain language attr) here for dev. Change when there is a col with the actual measures and then check that -->
        <td v-if="item.bl_measures ==='Ja'" class="text-start">
          <v-btn icon
                 ref="expandBtn"
                 @click="expand(!isExpanded)"
                 class="v-data-table__expand-icon"
                 :class="{'v-data-table__expand-icon--active' : isExpanded}">
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </td>
      </template>
      <!-- Expansion TD for measures -->
      <template v-slot:expanded-item="{ headers, item }" >
        <td :colspan="headers.length" class="pa-0 rounded-0">
          <div v-for="(el) in JSON.parse(item.measures)"
            :key="el.mn_title">
            <v-card>
              <v-card-title>
                Titel der Maßnahme: {{ el.mn_title }}
              </v-card-title>
              <v-col>
                <v-img>
                  <v-img
                    max-width="300"
                    :src="el.mn_img"
                    :alt="el.mn_title"
                  ></v-img>
                </v-img>
              </v-col>
              <v-list-item dense>
                <v-list-item-content>
                  Maßnahmen-Kategorie:
                  {{ el.mn_oberthema }} |
                  {{ el.mn_mittelthema }} |
                  {{ el.mn_unterthema }}
                  <br>
                  Zeitraum: {{ parseDate(el.mn_start) }} bis  {{ parseDate(el.mn_end) }}
                  <br>
                  Kosten: {{ el.mn_cost.toLocaleString() }} €
                </v-list-item-content>
              </v-list-item>
              <v-card-text>{{ el.mn_text }} </v-card-text>
              <v-list-item dense>
                <v-list-item-content>
                  Ansprechpartner: {{ el.mn_name_anspr }} <br>
                  Rolle Anspr.: {{ el.mn_email_anspr }} <br>
                  Kontakt Anspr.: {{ el.mn_role_anspr }} <br>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-divider></v-divider>
          </div>
        </td>
      </template>
      <!-- Highlighting on name and convoy members. We are essentially replacing the text so need to re-capitalize it either way  -->
    <template #item.name_gemeinde="{ value }">
        <div v-if="search.length > 1" :inner-html.prop="value | highlight(search) | capitalize(search)"></div>
        <div v-else :inner-html.prop="value | capitalize(search)"></div>
    </template>
    <template #item.convoy_nachbarn="{ value }">
        <div v-if="search.length > 1" :inner-html.prop="value | highlight(search) | capitalize(search)"></div>
        <div v-else :inner-html.prop="value | capitalize(search)"></div>
    </template>
    <template #[`item.wp_url`]="{ value,item }">
    <a target="_blank" :href="value">
      Wärmeplan {{item.city_name}} (extern)
    </a>
  </template>

    </v-data-table>

    </v-card>

  </v-container>
</template>

<script>
import { Mapable } from '../../../src/mixins/Mapable';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import { WguEventBus } from '../../../src/WguEventBus'

export default {
  name: 'vue-table',
  mixins: [Mapable],
  created () {
    this.attrFilter();
    WguEventBus.$on('city-value', (cityValue) => {
      // make the OL map accessible in this component
      this.search = cityValue;
      this.triggerExpand();
    });
  },
  props: {
    externalSearch: { type: String, required: false, default: '' }
  },
  data () {
    return {
      layerID: 'fvp_waermeplan',
      layerFeatures: [],
      layerAttributes: [],
      vectorSource: [],
      textSearchData: [], // Data after applying  text filters
      attrSearchData: [],
      search: this.externalSearch, // Search input
      expanded: [],
      einwohnerValue: 0,
      einwohnerOptions: [0, 10000, 100000],
      einwohnerFilterGreater: true,
      measuresOptions: [
        { title: 'Ausbau Erneuerbare Energien' },
        { title: 'Energieeffizienz' },
        { title: 'Begleitende Maßnahmen, Konzepte und Kommunikation' },
        { title: 'Sonstiges' },
        { title: '[Kein Filter]', value: null }
      ],
      measureSearchData: [],
      selectedMeasure: '',
      bl_konvoi: null,
      bl_vereinfacht: null,
      bl_verkuerzt: null,
      bl_measures: null,
      filterCriteria: {},
      headers: [
        {
          text: 'Name',
          value: 'name_gemeinde',
          key: 'name_gemeinde',
          sortable: true
        },
        {
          text: 'PLZ',
          value: 'plz',
          key: 'plz',
          sortable: true
        },

        {
          text: 'Landkreis',
          value: 'name_lkr',
          key: 'name_lkr',
          sortable: true
        },

        {
          text: 'Einwohnerzahl',
          value: 'bevoelkerung',
          key: 'bevoelkerung',
          sortable: true
        },
        {
          text: 'Im Konvoi',
          value: 'bl_konvoi',
          key: 'bl_konvoi',
          sortable: true
        },
        {
          text: 'Konvoi-Partner',
          value: 'convoy_nachbarn',
          key: 'convoy_nachbarn',
          sortable: true
        },
        {
          text: 'Vereinfachtes Verfahren',
          value: 'bl_vereinfacht',
          key: 'bl_vereinfacht',
          sortable: true
        },
        {
          text: 'Verkürztes Verfahren',
          value: 'bl_verkuerzt',
          key: 'bl_verkuerzt',
          sortable: true
        },
        {
          text: 'Link Wärmeplan',
          value: 'wp_url',
          key: 'wp_url',
          sortable: true
        },
        {
          text: 'Datum Veröffentlichung',
          value: 'veroeffentlicht_locale',
          key: 'veroeffentlicht_locale',
          sortable: false
        },
        {
          text: 'Maßnahmen veröffentlicht',
          value: 'bl_measures',
          key: 'bl_measures',
          sortable: true
        },
        // Expansion column
        { text: 'Maßnahmen', value: 'data-table-expand' }
      ]
    };
  },
  methods: {

    /*
      Attribute filter button content from bool to human language
      TODO: i18n
    */
    boolToLang (input) {
      if (input === true) {
        return 'Ja';
      } else if (input === false) {
        return 'Nein';
      } else if (input === null) {
        return 'Alle';
      }
    },
    /*
      Cycle the attribute button values between true false or deletion from criteria
    */
    cycleValue (key) {
      // Cycle the variable's value
      if (this[key] === null) {
        this[key] = true;
      } else if (this[key] === true) {
        this[key] = false;
      } else if (this[key] === false) {
        this[key] = null;
      }
      // Update the filterCriteria object
      if (this[key] === null) {
        // If the value is null, delete the key from the object
        delete this.filterCriteria[key];
      } else {
        // Otherwise, set the key to the new value
        this.filterCriteria[key] = this[key];
      }
      /*
        Due to vues pitifalls with tracking objects and arrays changes, recalculate filters explicitely each time
      */
      this.adjustIcons();
      this.attrFilter();
    },
    /*
      Run data requests and filters first time to fill table
    */
    onMapBound () {
      this.getVectorSource();
      this.getLayerFeatures();
      this.adjustIcons();
      this.attrFilter();
    },
    /*
      Get vector source
    */
    getVectorSource () {
      const layers = this.map.getLayers().getArray();
      const vectorLayer = layers.filter(layer => layer.get('lid') === this.layerID)[0];
      this.vectorSource = vectorLayer.getSource();
    },
    /*
      Get the features from the target vector layer
    */
    async getLayerFeatures () {
      try {
        this.layerFeatures = this.vectorSource.getFeatures();
        this.layerFeatures.forEach((feature) => {
          const attributes = feature.getProperties();
          this.layerAttributes.push(attributes);
        });
      } catch (error) {
        console.error('Failed to fetch WFS data:', error);
      }
    },
    /*
      Loop over the different possible inhabitant filter values as per customer request
    */
    einwohnerValueHandler () {
      const currentIndex = this.einwohnerOptions.indexOf(this.einwohnerValue);
      const nextIndex = (currentIndex + 1) % this.einwohnerOptions.length;
      this.einwohnerValue = this.einwohnerOptions[nextIndex];
    },
    /*
    * Filter out features that do not match the search filters
    */
    adjustIcons () {
      const measuresStyle = new Style({
        image: new Icon({
          src: './static/icon/location_green.svg',
          declutterMode: 'declutter'
        })
      });
      const kennzahlenStyle = new Style({
        image: new Icon({
          src: './static/icon/location_blue.svg',
          declutterMode: 'declutter'
        })
      });
      const basicStyle = new Style({
        image: new Icon({
          src: './static/icon/location_red.svg',
          declutterMode: 'declutter'
        })
      });

      const lowerSearch = this.search.toLowerCase();

      this.vectorSource.getFeatures().forEach((feature) => {
        const featureName = feature.get('city_name');
        const hasMeasures = feature.get('bl_measures');
        const hasKennzahlen = feature.get('bl_kennzahlen');
        const measures = feature.get('measures');
        const verkuerzt = feature.get('bl_verkuerzt');
        const vereinfacht = feature.get('bl_vereinfacht');
        const konvoi = feature.get('bl_konvoi');
        const bevoelkerung = feature.get('bevoelkerung');
        /*
          Always set styles
          Then set everything that does not match as empty style
        */
        if (hasMeasures) {
          feature.setStyle(measuresStyle)
        } else if (hasKennzahlen) {
          feature.setStyle(kennzahlenStyle)
        } else {
          feature.setStyle(basicStyle)
        }
        // Text search
        if (this.search && !featureName.toLowerCase().includes(lowerSearch)) {
          feature.setStyle(new Style({}))
        }

        // Feature search
        // Check if condition is in filtercriteria and set invisible if not
        if (
          (this.filterCriteria.bl_verkuerzt != null && verkuerzt === !this.filterCriteria.bl_verkuerzt) ||
          (this.filterCriteria.bl_vereinfacht != null && vereinfacht === !this.filterCriteria.bl_vereinfacht) ||
          (this.filterCriteria.bl_konvoi != null && konvoi === !this.filterCriteria.bl_konvoi) ||
          (this.filterCriteria.bl_measures != null && hasMeasures === !this.filterCriteria.bl_measures)
        ) {
          feature.setStyle(new Style({}));
        }

        if (measures) {
          // if a measure is selected and if the measures does NOT contain its current value
          if (this.selectedMeasure && !JSON.parse(measures).some(m => m.mn_oberthema === this.selectedMeasure)) {
            feature.setStyle(new Style({}));
          }
        } else if (this.selectedMeasure) {
          feature.setStyle(new Style({}));
        }

        // Pop search
        if (this.einwohnerFilterGreater && bevoelkerung < this.einwohnerValue) {
          feature.setStyle(new Style({}));
        } else if (!this.einwohnerFilterGreater && bevoelkerung > this.einwohnerValue) {
          feature.setStyle(new Style({}));
        }
      });
    },
    /*
      Filtering on text search
    */
    textFilter () {
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        this.textSearchData = this.layerAttributes.filter((item) =>
          Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchLower)
          )
        );
      } else {
        this.textSearchData = this.layerAttributes; // Reset if no search term
      }
    },
    /*
      Filtering on attribute buttons
      Fed by what is inside filterCriteria
    */
    attrFilter () {
      this.textFilter();
      // If a filter on attrs or measures was selected
      if (Object.keys(this.filterCriteria).length > 0 || this.selectedMeasure) {
        // Filter on data already filtered on previous  text search
        this.attrSearchData = this.textSearchData.filter(attr => {
          // Check if any of the datas kvp match any filter criteria
          return Object.keys(this.filterCriteria).every(key => {
            return attr[key] === this.filterCriteria[key];
          });
        })
        // .filter(obj => {
        //   if (obj.measures) {
        //     const meas = JSON.parse(obj.measures);
        //     return meas.some(item => item.mn_oberthema === this.selectedMeasure);
        //   } else return true
        // });
      } else this.attrSearchData = this.textSearchData;
    },
    measureFilter () {
      this.attrFilter();
      if (!this.selectedMeasure) return;
      this.attrSearchData = this.attrSearchData.filter(obj => {
        if (obj.measures) {
          const meas = JSON.parse(obj.measures);
          return meas.some(item => item.mn_oberthema === this.selectedMeasure);
        } else return false;
      });
    },
    parseDate (dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString('de-DE');
    },
    triggerExpand () {
      // Access the ref and trigger the click event
      if (this.search && this.$refs.expandBtn) {
        this.$refs.expandBtn.$el.click();
      }
    }
  },
  computed: {
    /*
      Unwrap the feature attr. to present in table
      Convoy neighbour array to String sep by comma
      Inhabitants with locale thousands separator
      Booleans to Ja / Nein
    */
    modifiedData () {
      return this.attrSearchData.map(obj => {
        const updatedObj = {
          ...obj,
          veroeffentlicht_locale: obj.veroeffentlicht,
          convoy_nachbarn: (JSON.parse(obj.convoy_nachbarn) ?? []).join(', '), // Array to separate Strings. JSON.parse so empty array becomes empty string, not null, which causes an error with .join
          bevoelkerung: obj.bevoelkerung.toLocaleString()
        };

        // Convert boolean properties to "Ja" / "Nein"
        for (const key in updatedObj) {
          if (typeof updatedObj[key] === 'boolean') {
            updatedObj[key] = updatedObj[key] ? 'Ja' : 'Nein';
          }
        }
        return updatedObj;
      });
    }
  },
  watch: {
    search () {
      this.adjustIcons();
      this.textFilter();
    },
    filterCriteria () {
      this.adjustIcons()
      this.measureFilter();
    },
    einwohnerValue () {
      this.adjustIcons();
    },
    einwohnerFilterGreater () {
      this.adjustIcons();
    },
    selectedMeasure () {
      this.adjustIcons();
      this.measureFilter();
    }
  },
  filters: {
    highlight: function (value, query) {
      return value.replace(new RegExp(query, 'ig'), '<span class=\'red\'>' + query + '</span>')
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};
</script>

<style scoped>

.text-button {
  font-size: smaller !important;
}

</style>
